<template>
  <table-view
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable"
  >
    <template #header>
      <view-search-form
        ref="searchFormRef"
        :queryInfo.sync="queryInfo"
        :tool-list="['grade','campus', 'college', 'major', 'stuStatus','keyword']"
        @on-search="renderTable(1)">
<!--        :insert-select-all="[ 'college', 'major']"-->
        <el-form-item label="宿舍楼" prop="dormitoryId">
          <el-select
            size="small"
            v-model="queryInfo.dormitoryId"
            clearable
            filterable>
            <el-option
              v-for="{dormitoryName,id} in buildList"
              :label="dormitoryName"
              :value="id"
              :key="id" />
          </el-select>
        </el-form-item>
        <el-form-item label="学制">
          <el-select v-model="queryInfo.lengthOfSchooling" clearable size="small">
            <el-option
              v-for="{paramName,paramValue} in $store.state.systemParam.lengthOfSchoolingType"
              :key="paramValue"
              :label="paramName"
              :value="Number(paramValue)" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <PopoverSelectFields :check-list.sync="checkList"
                             :student-columns="studentColumns"
                             :init-check-list="initCheckList" />
        <ElDivider direction="vertical" />
        <el-button type="success" size="small" @click="()=>visibleDIYExportDialog=true">导出该筛选条件学生</el-button>
        <!--        <el-button type="success" size="small" @click="exportStudentInfo">导出该筛选条件学生</el-button>-->
        <el-button type="success" plain size="small" piain @click="visibleExportDialog=true">批量导出(带照片)
        </el-button>
        <upload-excel :permit-key="['stu:import:edit']"
                      :loading.sync="loading"
                      :api="$http.importExcelHttp.importStudent"
                      @on-download="$http.exportExcelHttp.exportStudentTemplate()"
                      @on-success="renderTable(1)" />
        <el-button v-permission="['stu:import:edit']"
                   type="danger"
                   size="small"
                   :disabled="!stuInfo.length"
                   @click="changeIntoNotReport"
                   v-if="canBatchSaveNoPay"
        >转入未缴费名单
        </el-button>
        <el-button v-permission="['stu:import:edit']" type="primary" size="small" @click="showDialog()"
        >添加学生
        </el-button>
      </div>
    </template>
    <!--  body  -->
    <el-table
      v-if="compCols.length"
      :data="tableData"
      style="width: 100%"
      border
      stripe @selection-change="selectStudent">
      <el-table-column type="selection" width="55" v-if="canBatchSaveNoPay" />
      <el-table-column v-for="(item) in compCols" :key="item.prop" :prop="item.prop" :label="item.label"
                       :align="item.align||'left'"
                       :min-width="item.minWidth" :width="item.minWidth?null:item.width">
        <template v-slot="{row}">
          <!-- showSubDialog的title属性没有上,借用来传递专业信息  -->
          <div class="flex" v-if="item.prop==='stuName'">
            {{ row.stuName }}
            <el-button type="text"
                       icon="el-icon-view"
                       @click="showSubDialog('visibleOnlyReadDialog','onlyReadDialogRef',row.id,row)">
            </el-button>
          </div>
          <template v-else-if="item.prop==='sexType'">
            {{ +row.sexType === 1 ? '男' : '女' }}
          </template>
          <template v-else-if="item.prop==='roomName'">
            <span v-if="row.dormitoryName && row.dormitoryBedNo"
            >{{ row.dormitoryName }}{{ row.roomName }}室{{
                row.dormitoryBedNo
              }}号床</span>
            <span class="font-grey" v-else-if="row.stuStatus===2">已毕业</span>
            <span v-else>未分配</span>
          </template>
          <template v-else-if="item.prop==='payPassFlag'">
            <!--   免缴费登录  -->
            <el-switch
              v-permission="['stu:import:edit']"
              v-model="row.payPassFlag"
              active-color="var(--color-success)"
              inactive-color="#d0d6e8"
              :active-value="1"
              active-text="是"
              :inactive-value="0"
              inactive-text="否"
              @change="handleSwitch(row)" />
          </template>
          <template v-else-if="item.prop==='stuStatus'">
            {{ $http.getParamName(row.stuStatus, $store.state.systemParam.stuStatus) }}
          </template>
          <template v-else-if="item.prop==='headshot'">
            <!--  门禁照片  -->
            <template v-if="row.headshot">
              <el-popover
                placement="top"
                width="189"
                :title="`门禁照片：${row.stuName}`"
                lazy
                trigger="hover">
                <el-image style="width:179px; height:auto;" :preview-src-list="[$fileUrl + row.headshot]"
                          :src="$fileUrl + row.headshot" fit="contain" />
                <el-button slot="reference" type="text" size="mini">
                  <i class="el-icon-more" />
                </el-button>
              </el-popover>
            </template>
            <span v-else class="font-grey">--无--</span>
          </template>
          <span v-else-if="item.prop==='className'">
          {{ row.className || '未绑定' }}
          </span>
          <span v-else>{{ row[item.prop] }}</span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="220" fixed="right">
        <template v-slot="{row}">
          <el-button
            v-permission="['stu:import:edit']"
            type="primary"
            size="mini"
            @click="resetStuPassword(row)"
          >重置密码
          </el-button>
          <el-button
            v-permission="['stu:import:edit']"
            type="primary"
            size="mini"
            @click="showDialog(row.id,`-${row.stuName}`)"
          >编辑
          </el-button>
          <el-button
            v-permission="['stu:import:del']"
            size="mini"
            type="danger"
            @click="del(deleteStudent, row.id,`学生-${row.stuName}`)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--  编辑学生信息 dialog  -->
    <student-dialog ref="dialogRef" :visible.sync="visibleDialog" v-if="visibleDialog"
                    @on-close="renderTable" />
    <!--  查看学生信息 dialog  -->
    <student-only-read-dialog ref="onlyReadDialogRef" :visible.sync="visibleOnlyReadDialog"
                              v-if="visibleOnlyReadDialog" />
    <!--  导出带照片的学生excel dialog  -->
    <export-student-dialog ref="exportStudentDialogRef" :visible.sync="visibleExportDialog"
                           v-if="visibleExportDialog" />
    <!--    自定义导出字段 dialog -->
    <DialogExportStuSelect :visible.sync="visibleDIYExportDialog" v-if="visibleDIYExportDialog"
                           :student-columns="studentColumns"
                           :query-info="queryInfo" :check-list="checkList" />
  </table-view>
</template>

<script>
import { getStudentList, deleteStudent, addStudent } from '@/api/student'
import tableView from '@/vue/mixins/table-view'
import studentDialog from '@/views/pages/recruitManage/import-student/component/studentDialog.vue'
import StudentOnlyReadDialog from '@/views/pages/recruitManage/import-student/component/studentOnlyReadDialog.vue'
import ExportStudentDialog from '@/views/pages/recruitManage/import-student/component/exportStudentDialog.vue'
import DialogExportStuSelect from '@/components/common/components/DialogExportStuSelect.vue'
import { resetStuPasswordApi } from '@/api/system/user-api'
import PopoverSelectFields from '@/components/common/components/PopoverSelectFields.vue'
import { cloneDeep } from 'lodash'

export default {
  name: 'importStudent',
  components: {
    PopoverSelectFields,
    DialogExportStuSelect,
    ExportStudentDialog,
    StudentOnlyReadDialog,
    studentDialog
  },
  mixins: [tableView],
  data() {
    return {
      visibleOnlyReadDialog: false,
      visibleExportDialog: false,
      visibleDIYExportDialog: false,
      buildList: [],
      // 字段匹配
      initCheckList: ['examineNo', 'stuNo', 'grade', 'stuName', 'originalMajorName', 'stuStatus', 'sexType', 'collegeName', 'majorName', 'className', 'campusName', 'roomName', 'headshot', 'payPassFlag', 'remarks'],
      checkList: [],
      queryInfo: {
        grade: new Date().getFullYear(),
        lengthOfSchooling: null, // 学制
        stuStatus: null, // （0——未注册，1——在读，2——毕业）
        campusId: null,
        dormitoryId: null,
        collegeId: null,
        majorId: null
      },
      canBatchSaveNoPay: false,
      stuInfo: []
    }
  },
  created() {
    this.checkList = cloneDeep(this.initCheckList)
  },
  computed: {
    studentColumns() {
      if (this.$store.state.login.isAdmin) {
        return [...this.$store.state.systemParam.studentColumns, {
          prop: 'broadbandAccount',
          label: '宽带账号',
          width: '130'
        }]
      } else {
        return this.$store.state.systemParam.studentColumns
      }
    },
    compCols() {
      const result = this.studentColumns.filter((item) => {
        return this.checkList.includes(item.prop)
      })
      return result
    }
  },
  watch: {
    'queryInfo.campusId': function() {
      this.getDormBuild()
    }
  },
  methods: {
    deleteStudent, // 删除api
    // 转入未报到名单
    changeIntoNotReport() {
      this.$confirm('转到未报到名单, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http.updateStudentInfo({ stuInfoList: this.stuInfo }).then(() => {
            this.renderTable()
            this.$message.success('转入成功')
          }).catch()
        })
        .catch(() => {
          this.$message('已取消')
        })
    },
    // 选择学生
    selectStudent(stuIds) {
      this.stuInfo = stuIds.map((item) => {
        return {
          id: item.id,
          userId: item.userId,
          stuStatus: 6
        }
      })
    },
    // 获取学生列表
    async renderTable(pageNum) {
      await this.getTableData(getStudentList, pageNum)
    },
    // 获取楼栋
    async getDormBuild() {
      // 1 获取宿舍楼list
      try {
        const res = await this.$http.listDormitoryApi({ campusId: this.queryInfo.campusId })
        this.buildList = res.data
        // 3.由于数据量太大,所以不建议初始化时就加载整个学校的宿舍数据,除非有必要
      } catch (e) {
        console.error(e)
      }
    },
    handleSwitch(row) {
      this.$confirm(`${row.payPassFlag ? '开启后无需缴费即可登录 智慧南职APP、智慧迎新等应用。' : ''}请确认是否${row.payPassFlag ? '允许' : '禁止'}${row.stuName}(录取编号：${row.examineNo}）的免缴费登录？`, '免缴费登录').then(async () => {
        try {
          await addStudent(row)
          this.$message.success('操作成功')
        } catch (e) {
          console.error(e)
        } finally {
          await this.renderTable()
        }
      }).catch(() => {
        row.payPassFlag = row.payPassFlag ? 0 : 1
      })
    },
    resetStuPassword(row) {
      this.$confirm(`是否确定重置学生-${row.stuName}【${row.stuNo || row.examineCode}】的密码？`, '重置密码').then(async () => {
        try {
          await resetStuPasswordApi(row.userId)
          this.$confirm(`${row.stuName}【${row.stuNo || row.examineCode}】的密码已重置为123456。`, '重置成功', { showCancelButton: false }).then()
        } catch (e) {
          console.error(e)
        }
      }).catch(() => {
      })
    }
  }
}
</script>
